<div class="rankings-card">
  <div class="rankings-filters">
    <!-- Gender / Country -->
    <div class="filter-group">
      <label class="filter-checkbox">
        <input type="checkbox"
          [(ngModel)]="RankingMale"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>Male</span>
      </label>

      <label class="filter-checkbox">
        <input type="checkbox"
          [(ngModel)]="RankingFemale"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>Female</span>
      </label>

      <label class="filter-checkbox">
        <input type="checkbox"
          [(ngModel)]="RankingNZ"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>NZ Only</span>
      </label>
    </div>

    <!-- Matches Played -->
    <div class="filter-group boxed">
      <label class="group-title">Activity</label>

      <label class="filter-radio">
        <input type="radio"
          [(ngModel)]="Played"
          value="Zero"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>All</span>
      </label>

      <label class="filter-radio">
        <input type="radio"
          [(ngModel)]="Played"
          value="Last2Years"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>Last 2 Years</span>
      </label>

      <label class="filter-radio">
        <input type="radio"
          [(ngModel)]="Played"
          value="Last1Year"
          (ngModelChange)="ReCreateRankings(RankingSort)">
        <span>Last Year</span>
      </label>
    </div>

    <!-- Ranking Type -->
    <div class="filter-group boxed">
      <label class="group-title">Ranking Type</label>

      <label class="filter-radio">
        <input type="radio"
          [(ngModel)]="RankingSort"
          value="Singles"
          (ngModelChange)="ReCreateRankings('Singles')">
        <span>Singles</span>
      </label>

      <label class="filter-radio">
        <input type="radio"
          [(ngModel)]="RankingSort"
          value="Doubles"
          (ngModelChange)="ReCreateRankings('Doubles')">
        <span>Doubles</span>
      </label>
    </div>
    <div class="filter-group boxed">
      @if (DataService.Settings) {
        <label>Last Updated - {{ DataService.Settings[1].value | date:'dd-MMM-yy' }}</label>
      }
    </div>
  </div>
</div>

<div class="rankings-card" style="padding-top: 0px;">
  <div class="table-wrapper">
    <table class="rankings-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Country</th>
          <th>Singles</th>
          <th>Doubles</th>
          <th>Gender</th>
          <th>Matches</th>
          @if (RankingSort === 'Singles') {
            <th>Singles Grade</th>
          }
          @if (RankingSort === 'Doubles') {
            <th>Doubles Grade</th>
          }
          <th>TT</th>
          <th>Bad</th>
          <th>Sq</th>
          <th>T</th>
          <th>Change</th>
          <!-- <th *ngIf="DataService.Settings">{{ DataService.Settings[1].value | date:'dd-MMM-yy' }}</th> -->
        </tr>
      </thead>

      <tbody>
        @for (player of Rankings; track player; let i = $index) {
          <tr
            [ngClass]="newPLayerHighlightInRankings(player)">
            <td>{{ i + 1 }}</td>
            <td class="clickable"
              (click)="ViewHistoryOfPlayer(player)">
              {{ player.name }}
            </td>
            <td>{{ player.country }}</td>
            <td>{{ player.singlesPoints }}</td>
            <td>{{ player.doublesPoints }}</td>
            <td>{{ player.gender }}</td>
            <td>
              {{ RankingSort === 'Singles'
              ? player.SinglesMatchesPlayed
              : player.DoublesMatchesPlayed }}
            </td>
            @if (RankingSort === 'Singles') {
              <td>{{ player.SinglesGrade }}</td>
            }
            @if (RankingSort === 'Doubles') {
              <td>{{ player.DoublesGrade }}</td>
            }
            <td [ngClass]="ratingClass(player.TTRating)">{{ player.TTRating }}</td>
            <td [ngClass]="ratingClass(player.BadRating)">{{ player.BadRating }}</td>
            <td [ngClass]="ratingClass(player.SqRating)">{{ player.SqRating }}</td>
            <td [ngClass]="ratingClass(player.TRating)">{{ player.TRating }}</td>
            @if (RankingSort === 'Singles' && player.singlesRankingChange !== 0) {
              <td
                [ngClass]="player.singlesRankingChange > 0 ? 'positive' : 'negative'">
                {{ player.singlesRankingChange }}
              </td>
            }
            @if (RankingSort === 'Doubles' && player.doublesRankingChange !== 0) {
              <td
                [ngClass]="player.doublesRankingChange > 0 ? 'positive' : 'negative'">
                {{ player.doublesRankingChange }}
              </td>
            }
          </tr>
        }
      </tbody>
    </table>

  </div>
</div>


<!-- <div id="RankingFilters">
<div><label for="Male">Male</label><input type="checkbox" id="MaleRankings" name="Male" [(ngModel)]="RankingMale" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
<div><label for="Female">Female</label><input type="checkbox" id="FemaleRankings" name="Female" [(ngModel)]="RankingFemale" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
<div><label for="NZ">NZ Only</label><input type="checkbox" id="NZ" name="NZ" [(ngModel)]="RankingNZ" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
<div style="margin: 16px 10px 16px 10px; border: 1px solid black;">
  <div><label for="Matches0" title="no matches calculated yet">All</label><input type="radio" title="no matches calculated yet" id="Matches0" name="Matches0" [(ngModel)]="Played" value="Zero" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
  <div><label for="Last2Years" title="Played in last 2 years">Last 2 Years</label><input type="radio" title="Played in last 2 years" id="Last2Years" name="Last2Years" [(ngModel)]="Played" value="Last2Years" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
  <div><label for="Current" title="Played in last year">Last Year</label><input type="radio" title="Played in last year" id="Current" name="Current" [(ngModel)]="Played" value="Last1Year" (ngModelChange)="ReCreateRankings(RankingSort)" /></div>
</div>
<div id="RankingSort" style="margin: 16px 10px 16px 10px; border: 1px solid black;">
  <div><label for="Singles">Singles</label><input type="radio" id="SinglesRankings" name="Singles" value="Singles" [(ngModel)]="RankingSort" (ngModelChange)="ReCreateRankings('Singles')" /></div>
  <div><label for="Doubles">Doubles</label><input type="radio" id="DoublesRankings" name="Doubles" value="Doubles" [(ngModel)]="RankingSort" (ngModelChange)="ReCreateRankings('Doubles')" /></div>
</div>
</div>

<div id="TheRankingsTable">
  <table class="table-layout">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Country</th>
        <th>SinglesPoints</th>
        <th>DoublesPoints</th>
        <th>Gender</th>
        <th>Matches</th>
        <th *ngIf="RankingSort == 'Singles'">Singles Grade</th>
        <th *ngIf="RankingSort == 'Doubles'">Doubles Grade</th>
        <th>TT Rating</th>
        <th>Bad Rating</th>
        <th>Sq Rating</th>
        <th>T Rating</th>
        <th>{{DataService.Settings[1].value | date: 'dd-MMM-yy'}}</th>
      </tr>
    </thead>
    <tbody *ngFor="let player of Rankings; index as i">
      <tr [ngClass]="newPLayerHighlightInRankings(player)" >
        <td>{{i+1}}</td>
        <td (click)="ViewHistoryOfPlayer(player)" class="Pointer">{{player.name}}</td>
        <td>{{player.country}}</td>
        <td>{{player.singlesPoints}}</td>
        <td>{{player.doublesPoints}}</td>
        <td>{{player.gender}}</td>
        <td *ngIf="RankingSort == 'Singles'">{{player.SinglesMatchesPlayed}}</td>
        <td *ngIf="RankingSort == 'Doubles'">{{player.DoublesMatchesPlayed}}</td>
        <td *ngIf="RankingSort == 'Singles'">{{player.SinglesGrade}}</td>
        <td *ngIf="RankingSort == 'Doubles'">{{player.DoublesGrade}}</td>
        <td [ngClass]="player.TTRating > 80 ? 'VeryHighRating' : player.TTRating > 70 ? 'highRating' : ''">{{player.TTRating}}</td>
        <td [ngClass]="player.BadRating > 80 ? 'VeryHighRating' : player.BadRating > 70 ? 'highRating' : ''">{{player.BadRating}}</td>
        <td [ngClass]="player.SqRating > 80 ? 'VeryHighRating' : player.SqRating > 70 ? 'highRating' : ''">{{player.SqRating}}</td>
        <td [ngClass]="player.TRating > 80 ? 'VeryHighRating' : player.TRating > 70 ? 'highRating' : ''">{{player.TRating}}</td>
        <td *ngIf="RankingSort == 'Singles' && player.singlesRankingChange != 0" [ngClass]="player.singlesRankingChange > 0 ? 'greenText' : 'redText'">{{player.singlesRankingChange}}<i [ngClass]="player.singlesRankingChange > 0 ? 'upArrow' : 'downArrow'"></i><i [ngClass]="player.singlesRankingChange > 0 ? 'greenPole' : 'redPole'"></i></td>
        <td *ngIf="RankingSort == 'Doubles' && player.doublesRankingChange != 0" [ngClass]="player.doublesRankingChange > 0 ? 'greenText' : 'redText'">{{player.doublesRankingChange}}<i [ngClass]="player.doublesRankingChange > 0 ? 'upArrow' : 'downArrow'"></i><i [ngClass]="player.doublesRankingChange > 0 ? 'greenPole' : 'redPole'"></i></td>
      </tr>
    </tbody>
  </table>
</div> -->
